import React, { useState } from 'react'
import LogoAfterPayLarge from 'images/afterpay/logo_afterpay_large.svg'
import Logo1 from 'images/afterpay/logo_afterpay_modal_1.svg'
import Logo2 from 'images/afterpay/logo_afterpay_modal_2.svg'
import Logo3 from 'images/afterpay/logo_afterpay_modal_3.svg'
import Logo4 from 'images/afterpay/logo_afterpay_modal_4.svg'
import { Trans, useTranslation } from 'react-i18next'
import { AFTER_PAY_TERMS_URL } from '../../../urls'
import Chip from '@mui/material/Chip'
import AfterPayCircleIcon from '../../../../icons/AfterPayCircleIcon'
import ResponsiveDialog from '@components/ResponsiveDialog'

const AfterPayChip: React.FC<{ currency: string }> = ({ currency }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  if (currency !== 'USD') return null
  return (
    <>
      <Chip
        icon={<AfterPayCircleIcon viewBox='0 0 48 48' />}
        label={<span>Pay w/ Afterpay</span>}
        variant='outlined'
        classes={{ label: 'ml-5 uppercase text-11 font-semibold' }}
        sx={{ color: '#555', padding: '0 5px', borderRadius: '25px' }}
        onClick={() => setIsOpen(true)}
      />
      <ResponsiveDialog isOpenDialog={isOpen} setIsOpenDialog={setIsOpen}>
        <div className='flex items-center flex-col'>
          <img src={LogoAfterPayLarge} alt='Logo AfterPay' width='200' height='60' />
          <div className='mt-10 mb-40 text-32 leading-tight font-bold'>
            {t('shopNowPayLater', 'Shop now. Pay later.')} <br /> {t('alwaysInterestfree', 'Always interest-free')}
          </div>
          <div className='flex flex-col sm:flex-row justify-between items-center sm:items-baseline mb-50'>
            <div className='flex-1'>
              <div className='flex justify-center mb-16'>
                <img src={Logo1} alt='Afterpay modal logo 1' width='44' height='61' />
              </div>
              <p className='text-center text-base sm:text-sm font-bold mx-12'>
                {t('addYourFavoritesToCart', 'Add your favorites to cart')}
              </p>
            </div>
            <div className='flex-1'>
              <div className='flex justify-center mb-16'>
                <img src={Logo2} alt='Afterpay modal logo 2' width='68' height='46' />
              </div>
              <p className='text-center text-base sm:text-sm font-bold mx-12'>
                {t('selectAfterpayAtCheckout', 'Select Afterpay at checkout')}
              </p>
            </div>
            <div className='flex-1'>
              <div className='flex justify-center mb-16'>
                <img src={Logo3} alt='Afterpay modal logo 3' width='68' height='46' />
              </div>
              <p className='text-center text-base sm:text-sm font-bold mx-12'>
                {t(
                  'loginOrCreateAfterPayAccount',
                  'Log into or create your Afterpay account, with instant approval decision'
                )}
              </p>
            </div>
            <div className='flex-1'>
              <div className='flex justify-center mb-16'>
                <img src={Logo4} alt='Afterpay modal logo 4' width='58' height='58' />
              </div>
              <p className='text-center text-base sm:text-sm font-bold mx-12'>
                {t('afterPaySplitPayments', 'Your purchase will be split into 4 payments, payable every 2 weeks')}
              </p>
            </div>
          </div>
          <div className='text-sm sm:text-xs w-600 max-w-full leading-tight text-center'>
            <Trans i18nKey='afterPayTerms'>
              <div>
                You must be over 18, a resident of the U.S. and meet additional eligibility criteria to qualify. Late
                fees may apply. Estimated payment amounts shown on product pages exclude taxes and shipping charges,
                which are added at checkout.
              </div>
              <div>
                Click{' '}
                <a href={AFTER_PAY_TERMS_URL} rel='noreferrer noopener' target='_blank'>
                  here
                </a>{' '}
                for complete terms.
              </div>
              <div>
                Loans to California residents made or arranged pursuant to a California Finance Lenders Law license.
              </div>
              <div>©2020 Afterpay</div>
            </Trans>
          </div>
        </div>
      </ResponsiveDialog>
    </>
  )
}

export default AfterPayChip
